/* template */
<template minapp="mpx" xlang="wxml"><div v-if="(content !=null && content.length > 0)"><div class="es-card__success" v-if="(from==='success')"><es-icon color="#1473FF" name="exclamation-circle" size="14"/><div><div class="es-card__success-title">{{title}}</div><div v-for="(item, index) in (content)" :key="item.index" class="es-card__success-content">{{item}}</div></div></div><order-common-card @sideClick="toPurchaseNotice" :title="(title)" sideTitle="查看详情" sideIcon hideDivider v-else><div v-for="(item, index) in (content)" :key="item.index" class="es-card__content">{{index+1}}.{{item}}<div class="es-card__sizebox"></div></div></order-common-card></div></template>

/* styles */
<style scoped lang="stylus" src="./style.styl" mpxStyleOptions='{"mid":"mfd0d1b18"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mfd0d1b18"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexfd0d1b18%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexfd0d1b18%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mfd0d1b18"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexfd0d1b18/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'order-common-card':getComponent(require("../order-common-card/index.mpx?isComponent&outputPath=components%2Findexc3d6ce32%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
